import React, { memo } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@procsea/design-system'

import { useLocale } from 'src/hooks'

const NotFound = () => {
  const locale = useLocale()

  return (
    <div
      className="flex h-screen w-full flex-col items-center justify-center"
      data-e2e="not-found-page"
    >
      <h2 className="my-5 font-bold text-2xl">{gettext('404 - Not Found')}</h2>
      <h3 className="my-5 font-bold text-xl text-primary-900">{gettext('Ooops!')}</h3>
      <p className="my-4">{gettext("That page doesn't exist or is unavailable")}</p>

      <Link to={`/${locale}`} className="mt-8">
        <Button variant="primary">{gettext('Go Back to Home')}</Button>
      </Link>
    </div>
  )
}

export default memo(NotFound)
